import StompConnector from '@/controllers/StompConnector';
import { sounds } from '@/utils/Sounds';
import './emoji.css';

interface EmojiProps {
    emoji: string;
}

export const Emoji = ({ emoji }: EmojiProps) => {
    const sendEmoji = () => {
        sounds.playFX('click');
        StompConnector.sendEmoji(mapEmoji(emoji));
    };

    return (
        <button className="emoji" onClick={sendEmoji}>
            <img
                className="emoji__image"
                src={`assets/images/Emojis/${emoji}.png`}
                alt={`Emoji ${emoji}`}
            />
        </button>
    );
};

//TODO: check - Temporary solution to remmap emojis
export function mapEmoji(emoji: string) {
    switch (emoji) {
        case 'celebration':
            return '🎉';
        case 'flag':
            return '❤️';
        case 'shite':
            return '💩';
        default:
            return emoji;
    }
}
